import bucket from "./../sounds/bucket.ogg";
import boy from "./../sounds/boy.ogg";
import bird from "./../sounds/bird.ogg";
import girl from "./../sounds/girl.ogg";
import sandcastle from "./../sounds/sandcastle.ogg";
import shell from "./../sounds/shell.ogg";
import spade from "./../sounds/spade.ogg";
import sun from "./../sounds/sun.ogg";
import swimsuit from "./../sounds/swimsuit.ogg";

export const beach = [
    {
      title: "bird",
      polish: "ptak",
      image:
        "https://images.unsplash.com/photo-1605549305306-c10486f5fda3?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=747&q=80",
        sounds: bird,
    },
    {
      title: "boy",
      polish: "chłopiec",
      image:
        "https://images.unsplash.com/photo-1531984749403-ca6df86463ad?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80",
        sounds: boy,
    },
    {
      title: "bucket",
      polish: "wiaderko",
      image:
        "https://images.unsplash.com/photo-1606459881381-2240e5f87bd4?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
        sounds: bucket,
    },
    {
      title: "girl",
      polish: "dziewczynka",
      image:
        "https://images.unsplash.com/photo-1602573379740-399f20cada3d?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=782&q=80",
        sounds: girl,
    },
    {
      title: "sandcastle",
      polish: "zamek z piasku",
      image:
        "https://images.unsplash.com/photo-1581047989415-909d4ce5667d?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=786&q=80",
        sounds: sandcastle,
    },
    {
      title: "shell",
      polish: "muszelka",
      image:
        "https://images.unsplash.com/photo-1525658471940-622ce6bd9c7d?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=753&q=80",
        sounds: shell,
    },
    {
      title: "spade",
      polish: "łopatka",
      image:
        "https://images.pexels.com/photos/3932877/pexels-photo-3932877.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        sounds: spade,
    },
    {
      title: "sun",
      polish: "słońce",
      image:
        "https://images.unsplash.com/photo-1547243295-66b10aae2cb2?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=889&q=80",
        sounds: sun,
    },
    {
      title: "swimsuit",
      polish: "strój kąpielowy",
      image:
        "https://images.pexels.com/photos/4284291/pexels-photo-4284291.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        sounds: swimsuit,
    },
  ];
